import { Button } from '@mui/material';
import React,{ useState} from 'react'

function ButtonList(props) {
    const [isDisabled, setIsDisabled] = useState(false);

    const handleClick = (data) => {
        props.getData(2)
        setIsDisabled(true);
    
        setTimeout(() => {
          setIsDisabled(false);
        }, 1000); 
      };
  return (
    <div className='button-all' >
        <Button variant="contained" onClick={()=>{ props.getData(1) }} className='btn ask-me'>Ask me anything</Button>
        <Button variant="contained" type='button' className='btn feed-back' onClick={()=>{ handleClick(2) }}>Feedback</Button>
        <Button type='button' className='btn contact-us' onClick={()=>{ handleClick(3) }}>Contact us</Button>
      </div>
  )
}

export default ButtonList